import { render, staticRenderFns } from "./AndroidProjects.vue?vue&type=template&id=927418d0"
import script from "./AndroidProjects.vue?vue&type=script&lang=js"
export * from "./AndroidProjects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports